import { Controller } from '@hotwired/stimulus'

// This controller is used to load a turbo frame from a turbo stream.
//
// Usage:
//   <template data-controller="load-turbo-frame" data-load-turbo-frame-turbo-frame-id-value="my-turbo-frame-id" data-load-turbo-frame-src-value="/my-turbo-frame"></template>
//
//   # Forces the turbo frame with id "my-turbo-frame-id" to load "/my-turbo-frame"
//   <turbo-frame id="my-turbo-frame-id"></turbo-frame>
export default class extends Controller {
  static values = { frameId: String, src: String }

  connect () {
    this.reloadTurboFrame()
    this.element.remove()
  }

  reloadTurboFrame () {
    const turboFrameElement = document.getElementById(this.frameIdValue)
    if (turboFrameElement) {
      turboFrameElement.src = this.srcValue
      turboFrameElement.reload()
    } else {
      console.error(`Turbo frame with id ${this.frameIdValue} not found.`)
    }
  }
}
